import React, { useState } from 'react';
import { ROS } from "./components/ROS";
import Subscriber from "./components/Subscriber";
import PinAuth from './components/PinAuth';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const correctPin = '02470';

  // Service-worker handling lives in src/index.js (we unregister rather than
  // register — this app must always load fresh from the network).

  return (
    <div style={{ height: '100%', width: '100%', overflow: 'hidden' }}>
      {!isAuthenticated ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', backgroundColor: '#CCFFCC' }}>
          <PinAuth correctPin={correctPin} onAuthenticate={() => setIsAuthenticated(true)} />
        </div>
      ) : (
        <ROS>
          <Subscriber />
        </ROS>
      )}
    </div>
  );
}

export default App;